import React, { memo, useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import { useAuth } from "../../../context/AuthContext";

import SidebarContent from "./SidebarContent";

const Sidebar = ({ mobileOpen, closeMobile }) => {
  const { user } = useAuth();
  const role = user?.role;
  const location = useLocation();

  const [expanded, setExpanded] = useState(false);

  // Collapse hover state on route change
  useEffect(() => {
    setExpanded(false);
    closeMobile?.();
  }, [location.pathname]);


  const itemBase =
    "relative flex items-center h-14 px-4 border-y border-white first:border-t-0 transition-colors duration-200";

  const iconCol =
    "w-10 flex justify-center shrink-0 text-white";

  const labelBase =
    "absolute left-16 whitespace-nowrap text-white text-base font-medium " +
    "opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200";

  return (
    // <aside
    //   onMouseEnter={() => setExpanded(true)}
    //   onMouseLeave={() => setExpanded(false)}
    //   className={`
    //     fixed left-0 top-0 h-screen
    //     bg-[#6271bb]
    //     ${expanded ? "w-64" : "w-16"}
    //     transition-[width] duration-300
    //     overflow-hidden
    //     z-[100]
    //     shadow-xl
    //   `}
    // >
    <>
      {/* ================= DESKTOP HOVER ZONE ================= */}
      <div
        className="hidden md:block absolute top-0 left-0 h-full w-16 z-[100]"
        onMouseEnter={() => setExpanded(true)}
        onMouseLeave={() => setExpanded(false)}
      >
        <aside
          className={`
            absolute top-0 left-0 h-full
            bg-[#6271bb] shadow-xl
            transition-all duration-300
            ${expanded ? "w-64" : "w-16"}
          `}
        >
          <SidebarContent
            role={role}
            itemBase={itemBase}
            iconCol={iconCol}
            labelBase={labelBase}
            expanded={expanded}
          />
        </aside>
      </div>

      {/* ================= MOBILE SIDEBAR ================= */}
      <aside
        className={`
          md:hidden fixed top-0 left-0 h-screen w-64
          bg-[#6271bb] shadow-xl z-[100]
          transition-transform duration-300
          ${mobileOpen ? "translate-x-0" : "-translate-x-full"}
        `}
      >
        <div onClick={closeMobile} className="bolder text-white flex justify-end pe-4 pt-4">
          <button>X</button>
        </div>
        <SidebarContent
          role={role}
          itemBase={itemBase}
          iconCol={iconCol}
          labelBase={labelBase}
          expanded={true} // always expanded on mobile
        />
      </aside>
    </>
  );
};

export default memo(Sidebar);
